var _circle, _path, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoOutOfTwoLevels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 512 512",
    className: "dailoicon",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">", _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 256,
    r: 32,
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 256h96",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 32
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 256,
    r: 32,
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 32
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoOutOfTwoLevels);
export default __webpack_public_path__ + "static/media/two-out-of-two-levels.cdb5a38dd0de9ba6a6d44729eac15c1d.svg";
export { ForwardRef as ReactComponent };